import { render, staticRenderFns } from "./CompanyShowShortContacts.vue?vue&type=template&id=610eb9cc&scoped=true&"
import script from "./CompanyShowShortContacts.vue?vue&type=script&lang=js&"
export * from "./CompanyShowShortContacts.vue?vue&type=script&lang=js&"
import style0 from "./CompanyShowShortContacts.vue?vue&type=style&index=0&id=610eb9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610eb9cc",
  null
  
)

export default component.exports